import { useCallback, useEffect, useState } from 'react'
import LayerRegistry from '../data/LayerRegistry';
import { Style, Fill, Stroke } from 'ol/style'
import Analise from '../data/Analise'
var d3 = require("d3");

// const ORIGINAL_FEATURE_STYLE_PROPERTY_ANALISE = 'originalStyleAnalise';
var indexBaseLayers
export default (props) => {
    const [representacaoAtual, setRepresentacaoAtual] = useState()
    const [parametroSerie] = useState(props.parametroSerie)
    const restoreStyleFeatures = props.restoreStyleFeatures
    const legendaAnalise = props.legendaAnalise

    const cleanAndRestoreFeaturesBase = useCallback((representacaoLayers) => {
        if (parametroSerie) {
            if (!representacaoAtual || representacaoAtual === parametroSerie.representacao) { //Somente quando a alteracao da janela explorar nao seja de representacao
                restoreStyleFeatures(representacaoLayers.filter(bl => !(bl instanceof Promise)).map(rl => rl.olLayer.getSource().getFeatures()))
            }
        }
    }, [parametroSerie, restoreStyleFeatures, representacaoAtual])

    const montarLegenda = useCallback((params) => {
        const legenda = [];
        const olLayer = params.representacaoLayer && params.representacaoLayer.olLayer
        const features = olLayer && olLayer.getSource().getFeatures()

        const setLegenda = (grupo, index, cor) => {
            let qtd
            if ( params.indexBaseLayers === 2 ) {
                qtd = features && features.filter(feature => feature.get('gridcode') === grupo.id).length
            } else {
                qtd = params.analise.itensPorIdFeature && Object.values(params.analise.itensPorIdFeature).filter(analise=>analise.idGrupoMapaAnalise===grupo.id).length
            }

            legenda.push({
                title: grupo.inicio !== undefined && grupo.inicio !== null ? (grupo.fim !== undefined && grupo.fim !== null ? grupo.inicio.toLocaleString('pt-BR') + ' \u2014 ' + grupo.fim.toLocaleString('pt-BR'): '>'+grupo.inicio.toLocaleString('pt-BR')) : '<'+grupo.fim.toLocaleString('pt-BR'), 
                qtd: qtd,
                icon: {
                    icon: 'rectangle', 
                    color: cor[index], 
                    selected: true,
                    findAssociatedFeatures: () => olLayer && olLayer.getSource().getFeatures().filter(feature => {
                        if ( params.indexBaseLayers === 2 )
                            return feature.get('gridcode') === grupo.id
                        else 
                            return params.analise.itensPorIdFeature[feature.get('FID_1')] && params.analise.itensPorIdFeature[feature.get('FID_1')].idGrupoMapaAnalise===grupo.id
                    })
                }
            })
        }        

        params.acima.grupo && params.acima.grupo.forEach((grupo, index) => setLegenda(grupo, index, params.acima.cor));
        params.dentro.grupo && params.dentro.grupo.forEach((grupo, index) => setLegenda(grupo, index, params.dentro.cor));
        params.baixo.grupo && params.baixo.grupo.forEach((grupo, index) => setLegenda(grupo, index, params.baixo.cor));

        legenda.push({
            title: `Sem dados`, 
            qtd: params.indexBaseLayers !== 2 ? 
                (features ? features.filter(feature => params.analise.itensPorIdFeature && !params.analise.itensPorIdFeature[feature.get('FID_1')]).length : 0) :
                0,
            icon: {
                icon: 'rectangle', 
                color: '#fff', 
                selected: true, 
                findAssociatedFeatures: (() => olLayer && olLayer.getSource().getFeatures().filter(feature => {
                    if ( params.indexBaseLayers !== 2 )
                        return !params.analise.itensPorIdFeature[feature.get('FID_1')]
                    else
                        return false
                }))  
            }})

        legendaAnalise(legenda)
    }, [legendaAnalise])

    useEffect(() => {
        if (!props.parametroSerie) return
        
        let idFeature
        indexBaseLayers = props.parametroSerie.representacao
        if (props.parametroSerie.serie.serie === 'sp' || props.parametroSerie.serie.serie === 'ss') { //SOLO
            idFeature = 'gridcode'
            indexBaseLayers = 2
        } else {
            idFeature = 'FID_1'
        }
        
        const analiseMicrobaciasLayer = LayerRegistry.microbaciasAnalise;
        const analiseRedeDrenagemLayer = LayerRegistry.redesDeDrenagemAnalise;
        const analiseSoloLayer = LayerRegistry.solo;
        
        const baseLayers = [analiseMicrobaciasLayer, analiseRedeDrenagemLayer, analiseSoloLayer]
        
        analiseMicrobaciasLayer.olLayer.setStyle(null)
        analiseRedeDrenagemLayer.olLayer.setStyle(null)
        analiseSoloLayer && analiseSoloLayer.olLayer.setStyle(null)
        
        if (!props.analise) return
        
        (async()=>{
            cleanAndRestoreFeaturesBase(baseLayers)
            setRepresentacaoAtual(indexBaseLayers)

            const grupoBaixo = props.analise.grupos.filter(grupo => grupo.statusLimiteQuantificacao === 'ABAIXO')
            const grupoDentro = props.analise.grupos.filter(grupo => grupo.statusLimiteQuantificacao === 'DENTRO')
            const grupoAcima = props.analise.grupos.filter(grupo => grupo.statusLimiteQuantificacao === 'ACIMA')

            const grupoBaixoIds = grupoBaixo.map(grupo => grupo.id).reverse()
            const grupoDentroIds = grupoDentro.map(grupo => grupo.id)
            const grupoAcimaIds = grupoAcima.map(grupo => grupo.id)

            const colorsAbaixo = d3.schemeGreys[Math.max(3, grupoBaixoIds.length)].slice()
            const colorsDentro = d3.schemeYlOrBr[Math.max(3, grupoDentroIds.length)].slice().reverse()
            const colorsAcima = d3.schemeReds[Math.max(3, grupoAcimaIds.length)].slice().reverse()
            let colorContraste
            if (indexBaseLayers === 2) {
                if(grupoDentroIds.length === 0){
                    return [];
                }
                
                let indexMeio = grupoDentroIds.findIndex(group => group.inicio === 1 || group.fim === 1);
                if(indexMeio < 0) {
                    indexMeio = Math.floor(grupoDentroIds.length / 2);
                }
                
                const numberOfRedGroups = indexMeio;
                const numberOfGreenGroups = grupoDentroIds.length - indexMeio - 1;
                
                const greenColors = numberOfGreenGroups > 0 ? d3.schemeGreens[4].slice().reverse().slice(0, numberOfGreenGroups) : [];
                const redColors = numberOfRedGroups > 0 ? d3.schemeReds[4].slice().reverse().slice(0, numberOfRedGroups).reverse() : [];
                const corMeio = '#ffffd9';
                colorContraste = greenColors.concat(corMeio, redColors).reverse();
            } else {
                colorContraste = d3.schemeRdYlBu[Math.max(3, grupoDentroIds.length)].slice().reverse()
            }

            const createStyleForFeature = (color) => {
                if (indexBaseLayers === '1'){ //Drenagem
                    return new Style({
                        stroke: new Stroke({
                            color: color,
                            width: 2
                        })
                    })
                } else { // Microbacia e Solo
                    return new Style({
                        fill: new Fill({color: color})
                    })
                }
                //storeFeatureStyle(feature)
            }
            
            montarLegenda({ 
                baixo: {grupo: grupoBaixo, cor: colorsAbaixo},
                dentro: {grupo: grupoDentro, cor: props.parametroSerie.contrastar?colorContraste:colorsDentro}, 
                acima: {grupo: grupoAcima, cor: colorsAcima},
                analise: props.analise,
                representacaoLayer: baseLayers[indexBaseLayers],
                indexBaseLayers: indexBaseLayers
            })
            
            if (indexBaseLayers === '-1' || !baseLayers[indexBaseLayers]) {
                legendaAnalise(null)
                return
            }
            
            baseLayers[indexBaseLayers].olLayer.setStyle(feature => {
                let analise
                if (indexBaseLayers === 2) { //SOLO
                    const grupo = props.analise.grupos.filter(grupo => grupo.id === feature.get(idFeature))[0]
                    analise = grupo && {idGrupoMapaAnalise: grupo.id, statusLimiteQuantificacao: grupo.statusLimiteQuantificacao}
                } else {
                    analise = props.analise.itensPorIdFeature && props.analise.itensPorIdFeature[feature.get(idFeature)]
                }

                
                if (!analise) {
                    return createStyleForFeature('#fff')
                }

                if (props.parametroSerie.contrastar) {
                    return createStyleForFeature(colorContraste[grupoDentroIds.indexOf(analise.idGrupoMapaAnalise)])
                } else {
                    switch (analise.statusLimiteQuantificacao) {
                        case "ABAIXO":
                            return createStyleForFeature(colorsAbaixo[grupoBaixoIds.indexOf(analise.idGrupoMapaAnalise)])
                        case "DENTRO":
                            return createStyleForFeature(colorsDentro[grupoDentroIds.indexOf(analise.idGrupoMapaAnalise)])
                        case "ACIMA":
                            return createStyleForFeature(colorsAcima[grupoAcimaIds.indexOf(analise.idGrupoMapaAnalise)])
                        default:
                            break;
                    }
                }
            });

            console.log("Chama Analise.getInstance() map/Analise.js - props.analise")
            Analise.getInstance().setAnalise(props.analise)
            console.log("Chama Analise.getInstance() map/Analise.js - props.parametroSerie.contrastar")
            Analise.getInstance().setContraste(props.parametroSerie.contrastar)
        
        })()

    }, [cleanAndRestoreFeaturesBase, montarLegenda, props.analise, props.parametroSerie, legendaAnalise])

    // const clearStyle = (featuresAnalise) => {
    //     featuresAnalise.forEach(feature => {
    //         feature.setStyle(null)
    //         feature.unset(ORIGINAL_FEATURE_STYLE_PROPERTY_ANALISE, true);
    //     })
    // }

    // function storeFeatureStyle(feature){
    // 	const style = feature.getStyle();
    // 	if(style){
    // 		feature.set(ORIGINAL_FEATURE_STYLE_PROPERTY_ANALISE, style, true);
    // 	}
    // }

    return null
}